import { render, staticRenderFns } from "./AdminManagementAdminsExtra.vue?vue&type=template&id=e8b7c7f4&scoped=true&"
import script from "./AdminManagementAdminsExtra.vue?vue&type=script&lang=js&"
export * from "./AdminManagementAdminsExtra.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e8b7c7f4",
  null
  
)

export default component.exports